import { Component } from '@angular/core';

@Component({
  selector: 'td-wb-sticky-panel-bottom-content',
  styleUrls: ['sticky-panel-bottom-content.component.scss'],
  template: '<ng-content />'

})
export class StickyPanelBottomContentComponent {
}
